/**
 * V2 wrapper for Preview tab. Used by ViewDetailV2 (and future TableDetailV2 / MappingDetailV2).
 * @see Preview — shared implementation used by Table/Mapping details.
 */
import { IdCodeName } from '@/endpoints/schemas'
import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'

import { Preview } from './Preview'

export interface PreviewV2Props {
	node: StructureDto
	objectTypes?: IdCodeName[]
	showObjectTypes?: boolean
}

export const PreviewV2 = (props: PreviewV2Props) => <Preview {...props} />
